import {TareaDocumentoModel} from "../../models/tarea-documento.model";
import {
    EvkHttpService,
    EvkMainFilterPage, EvkOption,
    EvkPageComponentBase,
    EvkRequestType,
    EvkResponseType,
    MessageCrudService,
    RoutingService
} from "@evomatik/evk-common";
import {TareaDocumentoPageService} from "../../services/tarea-documento-page.service";
import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from "@angular/core";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import { ActivatedRoute, Router } from '@angular/router';
import {EstadoTareaEnum} from "../../enums/estado-tarea.enum";
import {catchError, delay, take} from "rxjs/operators";
import {MatDialog} from "@angular/material/dialog";
import {Observable, Subject, throwError} from "rxjs";
import {
    DiligenciaAsignacionComponent
} from "../../../wizard/componentes/section/sub-components/diligencias/diligencia-asignacion/diligencia-asignacion.component";
import {
    DiligenciaTurnarComponent
} from "../../../wizard/componentes/section/sub-components/diligencias/diligencia-turnar/diligencia-turnar-dialog/diligencia-turnar.component";
import {AuthUtils, EvkSecurityControlDataService} from "@evomatik/evk-seguridad";
import {CatalogosService} from "../../../expediente/services/catalogos.service";
import { MotivoRechazoComponent } from "../../../wizard/componentes/section/sub-components/diligencias/motivo-rechazo-component/motivo-rechazo.component";
import {
    SolicitarAutorizacionCreateComponent
} from "../../../wizard/componentes/section/sub-components/diligencias/solicitar-autorizacion/solicitar-autorizacion-create/solicitar-autorizacion-create.component";
import { MotivoCancelacionCreateComponent } from "../../../wizard/componentes/section/sub-components/diligencias/diligencia-motivo-cancelacion/motivo-cancelacion/motivo-cancelacion-create.component";
import { CancelarDiligenciaService } from "../../../wizard/componentes/section/sub-components/diligencias/diligencia-motivo-cancelacion/services/cancelar-diligencia.service";
import {DiligenciaTareaModel} from "../../models/diligencia-tarea.model";
import {
    EvkDiligenciaAceptarService
} from "../../../wizard/componentes/section/sub-components/diligencias/services/evk-diligencia-aceptar.service";
import { DiligenciasSharedActionsService } from "../../../wizard/componentes/section/sub-components/diligencias/services/diligencias-shared-actions.service";
import {
    EvkDiligenciaFinalizarService
} from "../../../wizard/componentes/section/sub-components/diligencias/services/evk-diligencia-finalizar.service";
import {
    EvkDiligenciaAutorizarService
} from "../../../wizard/componentes/section/sub-components/diligencias/services/evk-diligencia-autorizar.service";
import {
    MotivoRechazoCreateComponent
} from "../../../wizard/componentes/section/sub-components/diligencias/motivo-rechazo/motivo-rechazo-create/motivo-rechazo-create.component";
import { EvkFirmaElectronicaDialogComponent } from "../../../firma/componentes/firma-electronica/evk-firma-electronica-dialog/evk-firma-electronica-dialog.component";

export interface Accion {
    /**
     * Determina el label del botón asociado a la acción que aparecera en el menu
     */
    label: string;
    /**
     * Función que se ejecuta al seleccionar la acción en el menu
     */
    accion: (tarea?) => any;
    /**
     * Función para determinar cuando se debe mostrar la acción
     */
    show?: (tarea?) => boolean;

}

@Component({
    selector: 'lib-tarea-document-page',
    templateUrl: './tarea-documento-page.component.html',
    styleUrls: ['./tarea-documento-page.component.scss'],
    providers: [EvkMainFilterPage,TareaDocumentoPageService,DiligenciasSharedActionsService],
    encapsulation: ViewEncapsulation.None
})
export class TareaDocumentoPageComponent extends EvkPageComponentBase<TareaDocumentoModel> implements OnInit {
    columns: string[];
    @Input()
    canAdd = true;
    //canAdd = AuthUtils.hasRol('CREAR_INCIDENCIA');

    @Output()
    addDiligencia: EventEmitter<any> = new EventEmitter<any>();

    @Output()
    editDiligencia: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    public stop$ = new Subject<void>();
    public recargarPagina$ = new Subject<void>();
    public recargarPaginaAsObsv$ = this.recargarPagina$.asObservable().pipe(delay(10));
    username: string;
    multipleAut = false;

    public acciones = [
        {
            label: 'Editar',
            accion: (tarea) => {
                this.edit(tarea);
            },
            show: (tarea: TareaDocumentoModel) => {
                return this.checkEstatusExpediente(tarea);// this.checkEstatusPosFijo(tarea) && this.checkEstatusExpediente(tarea);
            },
        },
        /*{
            label: 'Ver Actuación',
            accion: (tarea) => {
                this.verDetalleDiligencia(tarea);
            },
            show: (tarea: TareaDocumentoModel) => {
                return this.checkEstatusFinalizada(tarea);
            },
        },*/
        /*{
            label: 'Crear copia de actuación',
            accion: (tarea: TareaDocumentoModel) => {
                this.crearCopiaTarea(tarea);
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return tarea.createdBy === localStorage.getItem('username') && this.checkTitularExpediente(tarea);
            },
        },*/
        /*{
            label: 'Agregar alias',
            accion: (tarea) => {
                this.addPostFijo(tarea);
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.checkEstatusPosFijo(tarea) && this.isTitularExpediente(tarea);
            },
        },*/
        {
            label: 'Reasignar',
            accion: (tarea) => {
                this.asignarDiligencia(tarea, 'Reasignar');
            },
            show: (tarea: TareaDocumentoModel) => {
                return (
                    this.canReasignar(tarea)
                );
            },
        },
        /*{
            label: 'Turnar',
            accion: (tarea) => {
                this.turnarDiligencia(tarea);
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    this.checkEstatusPorAtender(tarea) &&
                    tarea.tieneTurnado &&
                    this.hasRol('TURNADOR_TAREA')
                );
            },
        },*/
        {
            label: 'Asignar',
            accion: (tarea) => {
                this.asignarDiligencia(tarea, 'Asignar');
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.canAsignar(tarea);
            },
        },
        {
            label: 'Autorizar',
            accion: (tarea) => {
                this.autorizarDiligencia(tarea);
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.validarAutorizar(tarea);
            },
        },
        {
            label: 'Rechazar autorización',
            accion: (tarea) => this.rechazarAutorizarDiligencia(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.validarRechazarAutorizar(tarea);
            },
        },
        {
            label: 'Solicitar autorización',
            accion: (tarea) => this.mostrarSolicitarAutorizacionDialog(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.checkEstatusEnCorreccion(tarea);
            },
        },
        /*{
            label: 'Autorizar y solicitar otra autorización',
            accion: (tarea) => this.solicitarMultipleAutorizacion(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    this.checkCanMultipleAutorizacion(tarea) &&
                    this.validarAccionesCurrentUser(tarea) &&
                    this.multipleAut
                );
            },
        },*/
        {
            label: 'Responder',
            accion: (tarea) => this.responder(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    (
                        this.checkTipoAndEstatus('SOLICITUD', 'ASIGNADA', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'ENVIADA', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'RECIBIDA', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'EN ACTUALIZACIÓN', tarea) ||
                        this.checkTipoAndEstatus('EXTERNA', 'ASIGNADA', tarea) ||
                        this.checkTipoAndEstatus('EXTERNA', 'ENVIADA', tarea) ||
                        this.checkTipoAndEstatus('EXTERNA', 'RECIBIDA', tarea) ||
                        this.checkTipoAndEstatus('EXTERNA', 'EN ACTUALIZACIÓN', tarea)
                    ) &&
                    this.validaUsuario(tarea)
                );
            },
        },
        /*{
            label: 'Nueva actuación',
            accion: (tarea: TareaDocumentoModel) => {
                let idExpediente: number;
                let idConfigDiligencia: string;
                if (tarea.detalle.expediente != null) {
                    idExpediente = tarea.detalle.expediente.id;
                } else {
                    idExpediente = tarea.detalle.idExpediente;
                }
                idConfigDiligencia = tarea.detalle.idDiligenciaConfig != null ? tarea.detalle.idDiligenciaConfig : '';
                this.routingService.navigateTo(`/diligencia/nueva/asociar/${idExpediente}/${tarea.id}/${idConfigDiligencia}/${tarea.idNegocio}`);
            },
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    (
                        this.checkTipoAndEstatus('SOLICITUD', 'ASIGNADA', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'EN ACTUALIZACIÓN', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'ENVIADA', tarea) ||
                        this.checkTipoAndEstatus('SOLICITUD', 'RECIBIDA', tarea)
                    ) &&
                    this.validaUsuario(tarea) &&
                    this.validaRespuesta(tarea) &&
                    this.hasRol('EJECUTOR_TAREA', 'COLABORADOR_TAREA') &&
                    !this.hasRol('MEDICO_LEGISTA','PERITOS_ESPECIALIDAD_VICTIMAS') &&
                    tarea.diligencia.idDiligenciaConfig !== DiligenciaEnum.OFICIO_DERIVACION_ID
                );
            },
        },*/
        {
            label: 'Ver motivo de rechazo',
            accion: (tarea) => this.verRechazo(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    this.checkEstatusEnCorreccion(tarea) ||
                    this.checkEstatusRechazado(tarea)
                );
            },
        },
        {
            label: 'Aceptar',
            accion: (tarea) => this.aceptarDiligencia(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.canAceptarOrRechazar(tarea);
            },
        },
        {
            label: 'Rechazar',
            accion: (tarea) => this.rechazarDiligencia(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return this.canAceptarOrRechazar(tarea);
            },
        },
        {
            label: 'Ver respuesta',
            accion: (tarea:TareaDocumentoModel) => this.verDetalleDiligenciaRespuesta(tarea),
            show: (tarea:TareaDocumentoModel): boolean => {
                return (
                    this.checkEstatus(tarea, EstadoTareaEnum.FINALIZADA) && this.hasRespuesta(tarea)
                );
            },
        },
        /*{
            label: 'Cancelar',
            accion: (tarea) => this.cancelarDiligencia(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return true; //this.canCancelar(tarea) && this.isTitularExpediente(tarea);
            },
        },*/
        /*{
            label: 'Enviar',
            accion: (tarea: TareaDocumentoModel) => {
                this.enviar(tarea);
            },
            show: (tarea: TareaDocumentoModel) => {
                return this.checkEstatus(tarea, EstadoTareaEnum.POR_ENVIAR) && this.isCreador(tarea);
            },
        },
        {
            label: 'Ver motivo de cancelación',
            accion: (tarea) => this.verMotivoCancelacion(tarea),
            show: (tarea: TareaDocumentoModel): boolean => {
                return (
                    this.checkEstatusCancelada(tarea)
                );
            },
        },
        ,*/
        /*{
            label: 'Visualizar documento',
            accion: (tarea) => {
                this.showModalDocumentoFormato(tarea);
            },
            show: (tarea: TareaDocumentoModel) => {
                return this.verificarDiligenciaConfig(tarea);
            },
        },*/
    ];

    constructor(
        public pageService:TareaDocumentoPageService,
        public routingService: RoutingService,
        public route: ActivatedRoute,
        public router: Router,
        public dialog: MatDialog,
        public http: EvkHttpService,
        public messageCrudService: MessageCrudService,
        private evkSecurity: EvkSecurityControlDataService,
        private catalogoService: CatalogosService,
        private cancelarService: CancelarDiligenciaService,
        private aceptarSolicitudService: EvkDiligenciaAceptarService,
        private sharedActions: DiligenciasSharedActionsService,
        private finalizarService: EvkDiligenciaFinalizarService,
        private evkDiligenciaAutorizarService: EvkDiligenciaAutorizarService
    ) {
        super(pageService,TareaDocumentoModel);
        this.columns = ['tipo', 'asignado', 'unidad', 'detalle', 'fechaCreacion', 'estatus',  'acciones'];
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.username = this.evkSecurity.getUsuarioInfo().username;
        console.log('username: ', this.username)
    }

    add() {
        this.addDiligencia.emit();
    }

    edit(row: TareaDocumentoModel) {
        this.editDiligencia.emit(row);
    }

    muestraAccion(tarea: TareaDocumentoModel, accion: Accion) {
        return (accion.show) ? accion.show(tarea) : true;
    }

    obtenerEstatusActivo(row:TareaDocumentoModel){
        let estadoActivo = "";
        row.estadoTarea.forEach((estadoTarea) =>{
            if(estadoTarea.activo && estadoTarea.activo == true){
                estadoActivo = estadoTarea.estado.nombre;
            }
        });
        return estadoActivo;
    }
    getThemeClass(row:TareaDocumentoModel){
        let color = 'bg-primary';
        row.estadoTarea.forEach((estadoTarea) =>{
            if(estadoTarea.estado){
                switch (estadoTarea.estado.nombre) {
                    case 'EN ESPERA':
                        color = 'bg-waiting';
                        break;
                    case 'EN CORRECCIÓN':
                        color = 'bg-fixing';
                        break;
                    case 'ASIGNADA':
                        color = 'bg-assigned';
                        break;
                    case 'RECIBIDA':
                        color = 'bg-received';
                        break;
                    case 'CANCELADA':
                        color = 'bg-canceled';
                        break;
                    case 'FINALIZADA':
                        color = 'bg-finish';
                        break;
                    case 'ENVIADA':
                        color = 'bg-sent';
                        break;
                    case 'POR ATENDER':
                        color = 'bg-attend';
                        break;
                    case 'RECHAZADA':
                        color = 'bg-rejected';
                        break;
                    case 'EN ACTUALIZACIÓN':
                        color = 'bg-updating';
                        break;
                    case "POR ENVIAR":
                        color = 'bg-sending';
                        break;
                    case "EN AUTORIZACIÓN":
                        color = 'bg-authorizing';
                        break;
                    case "CREADA":
                        color = 'bg-primary';
                        break;
                }
            }
        });
        return color;
    }

    numeroAutorizaciones(tarea) {
        return tarea.estadoTarea.filter(({estado: {nombre}}) => nombre === 'EN AUTORIZACIÓN').length;
    }

    nuevaDIligenciaExterna() {
        this.router.navigate(['/diligencia/diligencia-externa']);
    }

    /*addPostFijo(data: TareaDocumentoModel) {
        this.sharedActions.addPostFijo(data).subscribe(() => {
            this.recargarPagina$.next();
        });
    }*/

    turnarDiligencia(data: TareaDocumentoModel) {
        const isTurnadoMultiple = data['turnadoMultiple'];
        const dialog = this.dialog.open(DiligenciaTurnarComponent, {
            width: '900px',
            data: {
                data,
                isTurnadoMultiple,
                idConfig: isTurnadoMultiple ? localStorage.getItem('unidadId') : data.detalle.idDiligenciaConfig,
            },
        });
        dialog.afterClosed().subscribe((response) => {
            this.messageCrudService.snackbarMessage('La actuación fue turnada con éxito');
            // if (response) {
            //     this.recargarPagina$.next();
            // }
        });
    }

    checkTitularExpediente(tarea: TareaDocumentoModel) {
        const {detalle: {idExpediente, titularExpediente, idTareaRespondida}, estadoTarea, tareaPadre} = tarea;
        const estatus = this.checkEstatusActivo(estadoTarea);
        return (estatus !== 'CREADA' && estatus !== 'POR ENVIAR') ||
            (idExpediente === null || idTareaRespondida ||
                titularExpediente === this.evkSecurity.getUsuarioInfo().username || tareaPadre);
    }

    checkEstatusPosFijo(tarea: TareaDocumentoModel) {
        let estado = '';
        const username = this.evkSecurity.getUsuarioInfo().username;
        tarea.estadoTarea.forEach((estatus) => {
            if (estatus.activo) {
                estado = estatus.estado.nombre;
            }
        });
        // if ((estado === 'CREADA' || estado === 'EN CORRECCIÓN' || estado === 'POR ENVIAR' || estado === 'EN ACTUALIZACIÓN') &&
        //     (tarea.detalle['titularExpediente'] === username || tarea.detalle['titularExterna'] === username ||
        //         _.get(tarea, 'usuarioAsignado.value', username) === username) &&
        //     (tarea['diligencia'].usuarioOrigen === null || (tarea['diligencia'].usuarioOrigen.value === this.evkSecurity.getUsuarioInfo().username ||
        //         (tarea['diligencia'].oficialSecretario != null && tarea['diligencia'].oficialSecretario.usuario === this.evkSecurity.getUsuarioInfo().username)))
        // ) {
        //     return true;
        // } else {
        //     return false;
        // }
    }

    showModalDocumentoFormato(tarea: TareaDocumentoModel){
        let readOnly = false;
        if(tarea.diligencia &&
            // tarea.diligencia.estadoTareaActivo &&
            // tarea.diligencia.estadoTareaActivo.estado &&
            // tarea.diligencia.estadoTareaActivo.estado.nombre === 'POR ENVIAR' &&
            tarea.diligencia.usuarioOrigen &&
            tarea.diligencia.usuarioOrigen.value === this.evkSecurity.getUsuarioInfo().username){
            readOnly = true;
        }
        if(tarea.diligencia /*&&
            tarea.diligencia.estadoTareaActivo &&
            tarea.diligencia.estadoTareaActivo.estado &&
            /*tarea.diligencia.estadoTareaActivo.estado.nombre === 'FINALIZADA'*/){
            readOnly = true;
        }

        // if(tarea.diligencia && !tarea.diligencia.estado && tarea.estadoTareaActivo){
        //     tarea.diligencia.estado = tarea.estadoTareaActivo.estado.nombre;
        // }

        /*this.catalogoService.getDiligenciaConfigById(tarea.diligencia.idDiligenciaConfig)
            .subscribe((diligenciaConfig) =>{
                console.log(diligenciaConfig);
                console.log(readOnly);
                this.dialog.open(EvkDocumentosContainerDialogComponent, {
                    panelClass: 'evk-documentos-container-dialog',
                    width: '90%',
                    disableClose: true,
                    data: {
                        diligencia: tarea.diligencia,
                        diligenciaConfig: diligenciaConfig,
                        expediente: tarea.diligencia.expediente,
                        readOnly: readOnly
                    }
                });
            })*/
    }

    verificarDiligenciaConfig(tarea: TareaDocumentoModel){
        return tarea && tarea.contieneFormatosParaGenerar;
    }

    checkEstatusFinalizada(tarea: TareaDocumentoModel) {
        // let estado = '';
        // let isTitularMasc = false;
        // const perfiles = localStorage.getItem('roles').split(',');
        // perfiles.forEach(perfil => {
            // if (perfil === RolEnum.TITULAR_UNIDAD_MASC) {
            //     isTitularMasc = true;
            // }
        // });
        // tarea.estadoTarea.forEach((estatus) => {
        //     if (estatus.activo) {
        //         estado = estatus.estado.nombre;
        //     }
        // });
        // if (estado === 'EN ACTUALIZACIÓN') {
        //     return tarea.createdBy !== localStorage.getItem('username');
        // }
        // if (estado === 'POR ENVIAR') {
        //     return tarea.usuarioAsignado && tarea.usuarioAsignado.value !== localStorage.getItem('username');
        // }
        // if (estado === 'CREADA') {
        //     return tarea.detalle['titularExpediente'] !== this.evkSecurity.getUsuarioInfo().username;
        // }
        return true;//(estado !== 'CREADA' && estado !== 'EN CORRECCIÓN') || (isTitularMasc);// || this.oficialSecretario !== '';
    }

    canValidarAutorizarRol() {
        return true;//AuthUtils.hasRol('AUTORIZADOR');
    }

    public validarAutorizar(tarea: TareaDocumentoModel){
        const organizacionUsuario = this.evkSecurity.getUsuarioInfo().organizacionLogica ? this.evkSecurity.getUsuarioInfo().organizacionLogica.id : this.evkSecurity.getUsuarioInfo().organizacionFisica.id;
        const diligencia = tarea.diligencia;
        if (
            diligencia
            && diligencia.estadoTareaActivo
            && diligencia.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN'
            && (
                (
                    diligencia.estadoTareaActivo?.usuarioAsignado === null
                    && diligencia.estadoTareaActivo.organizacion.value === organizacionUsuario
                )
                ||
                (
                    diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                )
            )
            && this.canValidarAutorizarRol()
            && this.numeroAutorizaciones(tarea) >= 1
            && !this.multipleAut
        ) {
            return true;
        }
        return false;
    }

    public validarRechazarAutorizar(tarea: TareaDocumentoModel){
        const organizacionUsuario = this.evkSecurity.getUsuarioInfo().organizacionLogica ? this.evkSecurity.getUsuarioInfo().organizacionLogica.id : this.evkSecurity.getUsuarioInfo().organizacionFisica.id;
        const diligencia = tarea.diligencia;
        if (
            diligencia
            && diligencia.estadoTareaActivo
            && diligencia.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN'
            && (
                (
                    diligencia.estadoTareaActivo?.usuarioAsignado === null
                    && diligencia.estadoTareaActivo.organizacion.value === organizacionUsuario
                )
                ||
                (
                    diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                )
            )
            && this.canValidarAutorizarRol()
        ) {
            return true;
        }
        return false;
    }

    checkEstatusEnAutorizacion(tarea: TareaDocumentoModel) {
        return (
            this.checkEstatusActivo(tarea.estadoTarea) === 'EN AUTORIZACIÓN' &&
            // this.tokenStorage.getRoles() !== undefined &&
            // this.tokenStorage.getRoles().includes('AUTORIZADOR') &&
            // tarea.organizacion.value === Number(localStorage.getItem('unidadId')) &&
            this.validaUsuario(tarea)
        );
    }

    checkEstatusRechazado(tarea: TareaDocumentoModel) {
        return this.checkEstatusActivo(tarea.estadoTarea) === 'RECHAZADA';
    }

    checkEstatusCancelada(tarea: TareaDocumentoModel) {
        return this.checkEstatusActivo(tarea.estadoTarea) === 'CANCELADA';
    }

    checkEstatusExpediente(tarea: TareaDocumentoModel) {
        // if (this.tokenStorage.getRoles().includes(RolEnum.AMP_RECEPTOR)) {
        //     return tarea['diligencia']['expediente'].idEstatusExpediente !== '2' && tarea['diligencia']['expediente'].idEstatusExpediente !== '3';
        // } else{
        //     return true;
        // }
        return true;
    }

    validaUsuario(tarea: TareaDocumentoModel) {
        this.username = this.evkSecurity.getgetTokenInfo().user_name;
        if (tarea.usuarioAsignado != null) {
            if (tarea.usuarioAsignado.value === this.username) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    }

    hasRol(...roles) {
        for (const rol of roles) {
            // if (this.tokenStorage.getRoles().includes(rol)) {
            //     return true;
            // }
        }
        return false;
    }

    checkEstatusPorAtender(tarea: TareaDocumentoModel) {
        return this.checkEstatusActivo(tarea.estadoTarea) === 'POR ATENDER';
    }

    checkEstatusPorAtenderAndCanAsignar(tarea: TareaDocumentoModel) {
        return this.checkEstatusActivo(tarea.estadoTarea) === 'POR ATENDER'; //&& this.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canValidarReasignarRol() {
        return true;//AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canReasignar(tarea: TareaDocumentoModel): boolean {
        const diligencia = tarea.diligencia;
        if (diligencia) {
            if (diligencia.estadoTareaActivo) {
                return diligencia.estadoTareaActivo &&
                    (diligencia.estadoTareaActivo.estado.nombre === 'ASIGNADA') &&
                    this.canValidarReasignarRol();
            }
            return false;
        }
        return false;
    }

    canValidarAsignarRol() {
        return true;//AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canAsignar(tarea: TareaDocumentoModel): boolean {
        const diligencia = tarea.diligencia;
        if (diligencia) {
            if (diligencia.estadoTareaActivo) {
                return diligencia.estadoTareaActivo
                    && diligencia.estadoTareaActivo.estado.nombre === 'POR ATENDER'
                    && this.canValidarAsignarRol();
            }
            return false;
        }
        return false;
    }

    checkEstatusAsignada(tarea: TareaDocumentoModel) {
        return this.checkEstatusActivo(tarea.estadoTarea) === 'EN ACTUALIZACIÓN' ||
            this.checkEstatusActivo(tarea.estadoTarea) === 'ASIGNADA';
    }

    checkEstatusEnCorreccion(tarea: TareaDocumentoModel) {
        return (
            this.checkEstatusActivo(tarea.estadoTarea) === 'EN CORRECCIÓN' &&
            /*this.tokenStorage.getRoles() !== undefined &&
            (this.tokenStorage.getRoles().includes('AUTORIZADOR') ||
                this.tokenStorage.getRoles().includes('EJECUTOR_TAREA') ||
                this.tokenStorage.getRoles().includes('COLABORADOR_TAREA') ||
                this.tokenStorage.getRoles().includes('AUXILIAR_EJECUTOR_TAREA') ||
                this.tokenStorage.getRoles().includes('EJECUTOR_SOLICITUDES_EXTERNAS')) &&*/
            (this.validaUsuario(tarea) || this.checkUsuarioAsignadoActivo(tarea.estadoTarea))
        );
    }

    checkCanMultipleAutorizacion(tarea: TareaDocumentoModel): boolean {
        return (
            this.checkEstatusActivo(tarea.estadoTarea) === 'EN AUTORIZACIÓN' /*&&
            this.tokenStorage.getRoles() !== undefined &&
            (this.tokenStorage.getRoles().includes('AUTORIZADOR') ||
                this.tokenStorage.getRoles().includes('EJECUTOR_TAREA') ||
                this.tokenStorage.getRoles().includes('COLABORADOR_TAREA') ||
                this.tokenStorage.getRoles().includes('AUXILIAR_EJECUTOR_TAREA') ||
                this.tokenStorage.getRoles().includes('EJECUTOR_SOLICITUDES_EXTERNAS'))*/
        );
    }

    viewOpcMultipleAuto() {
        // const idOrganizacion = this.tokenStorage.getValue('unidadId');
        // this.catalogoService.getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(idOrganizacion, 'AUTORIZACION').pipe(take(1)).subscribe(value => {
        //     this.multipleAut = value.length > 1;
        //
        // });
    }

    canValidarAceptarRol() {
        return true;//AuthUtils.hasRol('RECEPTOR_TAREA') || AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canAceptarOrRechazar(tarea: TareaDocumentoModel): boolean {
        const idOrganizaciones = [];
        idOrganizaciones.push(this.evkSecurity.getUsuarioInfo().idOrgFisica);
        idOrganizaciones.push(this.evkSecurity.getUsuarioInfo().idOrgLogica);
            if (tarea.estadoTareaActivo) {
                return tarea.estadoTareaActivo
                    && tarea.estadoTareaActivo.estado.nombre === 'EN ESPERA'
                    && this.canValidarAceptarRol()
                    &&
                    (
                        (
                            tarea.usuarioAsignado === null
                            && tarea.organizacion
                            && idOrganizaciones.includes(tarea.organizacion.value)
                        )
                        ||
                        (
                            tarea.estadoTareaActivo.usuarioAsignado
                            && tarea.estadoTareaActivo.usuarioAsignado.value === this.username
                        )
                    );
            }
            return false;

        return false;
    }

    checkEstatusEnEspera(tarea: TareaDocumentoModel) {
        return (
            this.checkEstatusActivo(tarea.estadoTarea) === 'EN ESPERA' /*&&
            this.tokenStorage.getRoles() !== undefined &&
            (this.tokenStorage.getRoles().includes('RECEPTOR_TAREA') ||
                this.tokenStorage.getRoles().includes('ADMINISTRADOR_BANDEJA_TAREAS'))*/
        );
    }

    canCancelarBakup(tarea: TareaDocumentoModel) {
        return (
            (this.checkEstatusActivo(tarea.estadoTarea) === 'CREADA' ||
                this.checkEstatusActivo(tarea.estadoTarea) === 'POR ENVIAR') /*&&
            this.tokenStorage.getRoles() !== undefined*/
            && this.hasRol('EJECUTOR_TAREA', 'COLABORADOR_TAREA', 'AUXILIAR_EJECUTOR_TAREA', 'EJECUTOR_SOLICITUDES_EXTERNAS')
            && !this.hasRol('ASISTENTE_EJECUTOR_TAREA')
            && this.isUsuarioAsignado(tarea));
    }

    canCancelar(tarea: TareaDocumentoModel) {
        let { subTipo } = tarea.diligencia.clasificacion;
        const validacion1 = (subTipo === 'Centro de atención a víctimas'
            && this.checkEstatusActivo(tarea.estadoTarea) !== 'FINALIZADA'
            && this.checkEstatusActivo(tarea.estadoTarea) !== 'CANCELADA'
            && this.checkEstatusActivo(tarea.estadoTarea) !== 'RECHAZADA'
            /*&& tarea.diligencia.createdBy === localStorage.getItem('username')*/);
        const validacion2 = (
            (this.checkEstatusActivo(tarea.estadoTarea) === 'CREADA' ||
                this.checkEstatusActivo(tarea.estadoTarea) === 'POR ENVIAR') /*&&
            this.tokenStorage.getRoles() !== undefined*/
            && this.hasRol('EJECUTOR_TAREA', 'COLABORADOR_TAREA', 'AUXILIAR_EJECUTOR_TAREA', 'EJECUTOR_SOLICITUDES_EXTERNAS')
            && !this.hasRol('ASISTENTE_EJECUTOR_TAREA')
            && this.isUsuarioAsignado(tarea));
        return validacion1 || validacion2;
    }


    checkEstatusActivo(estatusList: any[]): string {
        let estatusActivo = '';
        estatusList.forEach((estatus) => {
            if (estatus.activo) {
                estatusActivo = estatus.estado.nombre;
            }
        });
        return estatusActivo;
    }

    checkUsuarioAsignadoActivo(estatusList: any[]): boolean {
        let estatusActivo: any;
        estatusList.forEach((estatus) => {
            if (estatus.activo) {
                estatusActivo = estatus;
            }
        });
        return estatusActivo.usuarioAsignado === this.evkSecurity.getUsuarioInfo().username;
    }

    autorizarDiligencia(tarea: TareaDocumentoModel) {
        const diligencia = tarea.diligencia;
        if (!this.evkSecurity.getUsuarioInfo().persona.rfc || this.evkSecurity.getUsuarioInfo().persona.rfc === '') {
            this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
            return;
        }
        this.catalogoService.getTipoOrganizacionByOrganizacionById(diligencia.estadoTareaActivo.organizacion.value).subscribe((response: any) => {
            if (response && response.firma) {
                this.finalizarService.validCadenaOriginarRfc({...diligencia})
                    .pipe(take(1))
                    .subscribe((value: any) => {
                        this.showModalFirmaEAndExecuteAnyMethod(tarea.diligencia ,value, accion => this.openDialogAutorizar(tarea), 'Autorización');
                    });
            } else {
                this.openDialogAutorizar(tarea);
            }
        });
    }

    enAutorizar(tarea: any, tipo: string) {
        if (tipo === 'Autorizar') {
            this.validacionFirmaElectronica(tarea, 'En autorizar');
        } else {
            this.openDialogEnAutorizar(tarea, false);
        }
    }

    validacionFirmaElectronica(tarea: any, tipo: string) {
        // this.catalogoService.getOrganizacionById(tarea.organizacion.value).subscribe(({tipoOrganizacion: {firma}}: any) => {
        //     if (firma) {
        //         this.openDialogFirma(tarea, tipo, tipo === 'En autorizar');
        //     } else {
        //         this.validacionOpenDialog(tarea, tipo, !firma);
        //     }
        // });
    }

    validacionOpenDialog(tarea: any, tipo: string, formatoAutomatico?: boolean) {
        switch (tipo) {
            case 'Autorizar':
                this.openDialogAutorizar(tarea);
                break;
            case 'En autorizar':
                this.openDialogEnAutorizar(tarea, formatoAutomatico);
                break;
            default:
                break;
        }
    }

    openDialogFirma(tarea: any, tipo: string, formatoAutomatico?: boolean) {
        // this.catalogoService.getDiligenciaById(tarea.idNegocio).subscribe(diligencia => {
        //     const adicional = diligencia['adicionalFormData'];
        //     adicional['nombreEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('nombreCompletoUsuarioAutorizador');
        //     adicional['cargoEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('cargoUsuarioAutorizador');
        //     adicional['numeroEmpleadoEncargado'] = this.tokenStorage.getValueOfLocaleStorage('numEmpleadoUsuarioAutorizado');
        //     adicional['unidadEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('unidadUsuarioAutorizador');
        //     adicional['idDiligencia'] = diligencia.id;
        //     diligencia['adicionalFormData'] = adicional;
        //     this.catalogoService.updateAdicionalData({id: '', data: adicional}).subscribe(data => {
        //     });
        //
        //     this.cadenaOriginalService.getCadenaOriginal(tarea.idNegocio).subscribe(responseCadenaOriginal => {
        //         const rfc = sessionStorage.getItem('rfc');
        //         if (rfc === undefined || rfc === null || rfc.length <= 0) {
        //             this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
        //             return;
        //         }
        //         const datosFirma = {
        //             hash: 'sha1',
        //             message: responseCadenaOriginal.cadena,
        //             encode: 'base64',
        //             idDiligencia: tarea.idNegocio,
        //             username: localStorage.getItem('username'),
        //             rfc: rfc
        //         };
        //
        //         const dialogRef = this.dialog.open(EvkFirmaElectronicaDialogComponent, {
        //             width: '650px',
        //             panelClass: 'create-component-dialog-firma-electronica',
        //             disableClose: true,
        //             data: {
        //                 datos: datosFirma
        //             }
        //         });
        //         dialogRef.afterClosed().subscribe((response) => {
        //             if (response !== null) {
        //                 if (response.valid) {
        //                     const responseFirma = response.message;
        //                     const data = {
        //                         data: {
        //                             username: localStorage.getItem('username'),
        //                             nombreCompleto: localStorage.getItem('nombreCompleto'),
        //                             cadenaOriginal: responseFirma.cadenaOriginal,
        //                             origen: 'Autorización',
        //                             selloDigital: responseFirma.firma,
        //                             rfcCertificado: responseFirma.rfc,
        //                             noSerieCertificado: responseFirma.serial,
        //                             nombreServidorPublico: localStorage.getItem('nombreCompleto'),
        //                             noSerieCertificadoUsuario: responseFirma.serial,
        //                             fechaHoraCertificado: responseFirma.fechaHoraCertificado
        //                         },
        //                         id: ''
        //                     };
        //                     this.catalogoService.saveSignedMessage(tarea.idNegocio, data).subscribe(res => {
        //                         this.messageCrudService.snackbarMessage('La actuación se firmo exitosamente');
        //                         this.validacionOpenDialog(tarea, tipo, formatoAutomatico);
        //                     });
        //                 } else {
        //                     console.log('errorMessage', response.message.message);
        //                     this.messageCrudService.snackbarMessage(response.message.message);
        //                 }
        //             }
        //         });
        //     });
        // });
    }


    openDialogAutorizar(tarea: TareaDocumentoModel) {
        const diligencia = tarea.diligencia;
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de autorizar la actuación?',
            goonbtn: 'Autorizar',
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.evkDiligenciaAutorizarService.edit(diligencia).subscribe((response) => {
                    this.messageCrudService.snackbarMessage('La actuación se autorizo exitosamente');
                    confirmDialog.close();
                },
                (error) => {
                    console.log('error', error);
                    confirmDialog.close();
                }
            );
        });
    }

    openDialogAutorizarV2() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de autorizar la actuación?',
            goonbtn: 'Autorizar',
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.messageCrudService.snackbarMessage('La actuación se autorizo exitosamente');
            /*this.evkDiligenciaAutorizarService.edit(this.diligencia).subscribe((response) => {
                    this.messageCrudService.snackbarMessage('La actuación se autorizo exitosamente');
                    this.recargarPagina$.next();
                    confirmDialog.close();
                },
                (error) => {
                    console.log('error', error);
                    confirmDialog.close();
                }
            );*/
        });
    }

    openDialogEnAutorizar(tarea: any, automatico?: boolean) {
        // tarea.detalle['id'] = tarea.idNegocio;
        // const dialog = this.dialog.open(EnAutorizacionDiligenciaCreateComponent, {
        //     panelClass: 'create-component-dialog',
        //     width: '900px',
        //     data: {
        //         organizacionOrigen: tarea['organizacion'],
        //         diligencia: tarea['diligencia'],
        //         origen: 'paginador',
        //         formatoAutomatico: automatico
        //     },
        // });
        // dialog.afterClosed().subscribe((result) => {
        //     if (result) {
        //         this.messageCrudService.snackbarMessage('¡Solicitud de autorización enviada con exito!');
        //         this.recargarPagina$.next();
        //     }
        // });
    }

    verDetalleDiligencia(tarea: TareaDocumentoModel) {
        this.routingService.recordRoute();
        let detalle = 'ver-detalle-diligencia';
        if (tarea.detalle.tipo === 'EXTERNA') {
            detalle = 'ver-detalle-diligencia-externa';
        }
        this.router.navigate([`../${detalle}/${tarea.idNegocio}/${tarea.detalle['idDiligenciaConfig']}/${tarea.id}`], {relativeTo: this.route});
    }
    verDetalleDiligenciaRespuesta(tarea: TareaDocumentoModel) {
        tarea.tareaRespuestas.forEach((tareaRespuesta)=>{
            this.editDiligencia.emit(tareaRespuesta);
        })
    }

    rechazarAutorizarDiligencia(tarea: TareaDocumentoModel) {
        const dialog = this.dialog.open(MotivoRechazoCreateComponent, {
            panelClass: 'rechazar-component-dialog',
            width: '900px',
            data: {
                diligencia: tarea.diligencia,
            }
        });
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.messageCrudService.snackbarMessage('La actuación fue rechazada con éxito');
            }
        });
    }

    puedeCrearDiligenciasExternas(): boolean {
        return true;// (this.tokenStorage.getRoles() !== undefined && this.tokenStorage.getRoles().includes('EJECUTOR_SOLICITUDES_EXTERNAS'));
    }

    puedeConsultarPoderJudicial(): boolean {
        // const roles = this.tokenStorage.getRoles() !== undefined ? this.tokenStorage.getRoles() : null;
        // if (roles !== null) {
        //     return this.tokenStorage.getRoles().includes('AMP_UIC') ||
        //         this.tokenStorage.getRoles().includes('MP_UAC') ||
        //         this.tokenStorage.getRoles().includes('AMP_DE_ESTRATEGIAS_PROCESALES') ||
        //         this.tokenStorage.getRoles().includes('AMP_DE_IMPUGNACIONES') ||
        //         this.tokenStorage.getRoles().includes('AMP_DE_EJECUCION_PENAL') ||
        //         this.tokenStorage.getRoles().includes('AMP_UAC') ||
        //         this.tokenStorage.getRoles().includes('AMP_CON_DETENIDO');
        // }
        return false;

    }


    crearCopiaTarea(tarea: TareaDocumentoModel) {
        // this.sharedActions.crearCopiaTarea(tarea).subscribe((res) => {
        //     this.recargarPagina$.next();
        // });
    }

    responder(tarea: TareaDocumentoModel) {
        let idDiligenciaConfig = tarea.diligencia.idDiligenciaConfig;
        let idConfig = tarea.diligencia.expediente.idConfiguracionExpediente;
        let idExpediente = tarea.diligencia.expediente.id;
        this.router.navigate(['/diligencias/' + idConfig+'/'+ idExpediente+'/'+ idDiligenciaConfig+'/responder'+'/'+ tarea.diligencia.id]);
    }

    actualizarDiligenciaRoute(tarea: TareaDocumentoModel) {
        this.routingService.recordRoute();
        const nombreDiligencia = tarea.detalle.nombreDiligencia;
        // if (tarea.detalle.postFijo != null) {
        //     localStorage.setItem('postFijo', tarea.detalle.postFijo);
        // }
        // localStorage.setItem('nombreDiligencia', nombreDiligencia);
        const destinatario = this.route.snapshot.params['tipoBandeja'];

        if (tarea.detalle.idDiligenciaPadre) {
            this.router.navigate(
                // tslint:disable-next-line:max-line-length
                [`/diligencia/${destinatario}/actualizar/${tarea.detalle['idDiligenciaConfig']}/${tarea.detalle['idExpediente']}/${tarea.idNegocio}/${tarea.detalle.idDiligenciaPadre}`]
            );
        }

        if (!tarea.detalle.idDiligenciaPadre && tarea.tipoTarea !== 'EXTERNA') {
            this.router.navigate(
                [`/diligencia/${destinatario}/actualizar/${tarea.detalle['idDiligenciaConfig']}/${tarea.detalle['idExpediente']}/${tarea.idNegocio}`]
            );
        }

        if (tarea.tipoTarea === 'EXTERNA') {
            this.router.navigate(
                [`/diligencia/diligencia-externa/actualizar/${tarea.detalle['idDiligenciaConfig']}/${tarea.idNegocio}`]
            );
        }
    }

    verRechazo(tarea: TareaDocumentoModel) {
        this.sharedActions.verRechazo(tarea);
    }

    verMotivoCancelacion(tarea: TareaDocumentoModel) {
        this.sharedActions.verMotivoCancelacion(tarea);
    }

    checkTipoAndEstatus(tipo: string, estado: string, tarea: TareaDocumentoModel): boolean {
        return this.checkTipo(tipo, tarea) && tarea.estadoTarea.some((estadoTarea) => estadoTarea.activo && estadoTarea.estado.nombre === estado);
    }

    checkTipo(tipo: string, tarea: TareaDocumentoModel) {
        if (tipo === 'EXTERNA') {
            return tarea['diligencia'].clasificacion.tipo === 'SOLICITUD' && tarea['diligencia'].clasificacion.subTipo === 'Externa';
        }
        return tarea.tipoTarea === tipo;
    }

    creaDesglose(tarea: TareaDocumentoModel): Observable<EvkResponseType<any>> {
        const dataDesglose = {
            id: tarea.detalle.idExpediente,
            titularActual: {
                usuarioTitular: {
                    label: localStorage.getItem('nombreCompleto'),
                    value: sessionStorage.getItem('username'),
                    active: true,
                },
                organizacion: {
                    label: localStorage.getItem('unidad'),
                    value: localStorage.getItem('unidadId'),
                    active: true,
                },
            },
            folioDiligenciaOrigen: tarea.detalle.folio
        };
        const request: EvkRequestType<any> = {
            id: '',
            data: dataDesglose,
        };
        return this.http.post(`/seaged-expedientes-service/desglose/create`, request);
    }

    aceptarDiligencia(tarea: TareaDocumentoModel) {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de aceptar la actuación?',
            goonbtn: 'Aceptar',
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.aceptarSolicitudService.edit(tarea.diligencia).subscribe((response) => {
                this.messageCrudService.snackbarMessage('Actuación aceptada de forma exitosa.');
                confirmDialog.close();
            }, error => {
                this.messageCrudService.snackbarSimpleError('No se ha podido aceptar la actuación :' + error);
                confirmDialog.close();
            });
        });
    }

    rechazarDiligencia(tarea: TareaDocumentoModel) {
        const dialog = this.dialog.open(MotivoRechazoComponent, {
            panelClass: 'rechazar-component-dialog',
            width: '900px',
            data: {
                id: tarea['idNegocio'],
                idDiligenciaConfig: tarea.detalle.idDiligenciaConfig,
                createdBy: this.evkSecurity.getUsuarioInfo().username,
            },
        });
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.messageCrudService.snackbarMessage('La actuación fue rechazada con éxito');
                this.recargarPagina$.next();
            }
        });
    }

    asignarDiligencia(tarea: TareaDocumentoModel, origen: string) {
        const dialog = this.dialog.open(DiligenciaAsignacionComponent, {
            panelClass: 'asignacion-diligencia-dialog',
            width: '900px',
            data: {tarea: tarea, origen: origen, peritos: false},
        });

        dialog.afterClosed().subscribe((result: EvkOption) => {
            if (result) {
                this.messageCrudService.snackbarMessage('La actuación fue asignada con éxito');
            }
        });
    }

    cancelarDiligenciaBakup(tarea: TareaDocumentoModel) {
        // const confirmDialog = this.messageCrudService.openConfirmDialog({
        //     warn: '¿Está seguro de cancelar esta diligencia?',
        //     goonbtn: 'Aceptar',
        // });
        //
        // confirmDialog.componentInstance.resolveEvent.subscribe(() => {
        //     const aceptar = {
        //         idNegocio: tarea.idNegocio,
        //         createdBy: localStorage.getItem('username'),
        //     };
        //     const data = {
        //         id: 'NA',
        //         data: aceptar,
        //     };
        //     this.http.put(`/seaged-diligencias-service/diligencia/cancelar`, data).subscribe(
        //         (response) => {
        //             this.recargarPagina$.next();
        //             this.messageCrudService.snackbarMessage('La actuación se cancelo exitosamente');
        //             confirmDialog.close();
        //         },
        //         (error) => {
        //             console.log('error', error);
        //             confirmDialog.close();
        //         }
        //     );
        // });
    }

    cancelarDiligencia(tarea: TareaDocumentoModel) {
        console.log('Cancelar', tarea);
        const dil: DiligenciaTareaModel = new DiligenciaTareaModel();
        dil.id = tarea.diligencia.id;
        dil.idDiligenciaConfig = tarea.detalle.idDiligenciaConfig;
        dil.createdBy = this.evkSecurity.getUsuarioInfo().username;
        const dialog = this.dialog.open(MotivoCancelacionCreateComponent, {
            panelClass: 'motivo-cancelacion-dialog',
            width: '900px',
            data: { },
        });
        dialog.afterClosed().subscribe((response) => {
            if (response) {
                console.log(response);
                const diligencia = dil;
                diligencia['motivoEstado'] = response.motivo;
                this.cancelarService.edit(diligencia).subscribe(
                    (response) => {
                        this.messageCrudService.snackbarMessage('La actuación fue cancelada con éxito');
                    },
                    (error) => {
                        this.messageCrudService.snackbarError(error);
                    }
                );
            }
        });
    }

    validarAccionesCurrentUser(tarea: TareaDocumentoModel): boolean {
        return true;//(tarea.usuarioAsignado === null || tarea.usuarioAsignado.value === localStorage.getItem('username')) && tarea.createdBy !== localStorage.getItem('username');
    }

    validaRespuesta(tarea: TareaDocumentoModel): boolean {
        if (tarea.tareaRespuestas.length > 0) {
            return (this.checkEstatusActivo(tarea.tareaRespuestas[0].estadoTarea) !== 'EN AUTORIZACIÓN');
        }
        return true;
    }

    public isUsuarioAsignado({usuarioAsignado}) {
        return usuarioAsignado && usuarioAsignado.value === this.evkSecurity.getUsuarioInfo().username;
    }

    canResponder(row: any): boolean {
        const tareaRespuestas: any[] = row.tareaRespuestas;
        if (tareaRespuestas.length === 0) {
            return true;
        }
        return !tareaRespuestas.some(respuesta => respuesta.activo === true);

    }

    openConsultaPoderJudicial() {
        // const dialogRef = this.dialog.open(ConsultaPoderJudicialDialogComponent, {
        //     width: '90%',
        //     panelClass: 'create-component-dialog',
        //     disableClose: true,
        //     data: {}
        // });
    }

    showModalFirmaEAndExecuteAnyMethod(diligencia: any, datosFirma: any, metodoEjecutar: any, origen: string) {
        const dialogRef = this.dialog.open(EvkFirmaElectronicaDialogComponent, {
            width: '650px',
            panelClass: 'create-component-dialog-firma-electronica',
            disableClose: true,
            data: {
                datos: datosFirma,
            },
        });

        dialogRef.afterClosed().subscribe((dialogResponse) => {
            if (dialogResponse && dialogResponse.valid) {
                const responseFirma = dialogResponse.message;
                const dataFirmaE = this.finalizarService.buildDataFirmaE(responseFirma, origen);
                this.finalizarService.addFirmaToDiligencia(dataFirmaE, diligencia).subscribe(diligencia => {
                    metodoEjecutar();
                }, error => {
                    catchError(() => throwError('No se ha podido registrar la firma en la actuación.'));
                });
            } else {
                const message = dialogResponse && dialogResponse.message && dialogResponse.message.message ? dialogResponse.message.message : 'se cancelo la firma electronica';
                this.messageCrudService.snackbarMessage('La firma electrónica no es válida: ' + message);
            }
        });
    }

    mostrarSolicitarAutorizacionDialog(tarea: TareaDocumentoModel) {
        const dil = tarea['diligencia'];
        this.catalogoService.getTiposPatron(dil.idDiligenciaConfig).subscribe((config) => {
            const dialogRef = this.dialog.open(SolicitarAutorizacionCreateComponent, {
                panelClass: 'create-component-dialog',
                width: '90%',
                disableClose: true,
                data: {
                    diligencia: dil,
                    diligenciaConfig: config
                }
            });

            dialogRef.afterClosed().pipe(take(1)).subscribe(response => {
                this.messageCrudService.snackbarMessage('La actuación fue autorizada con éxito');
                // if (response) {
                //     this.recargarPagina$.next();
                // }
            });
        });
    }

    solicitarMultipleAutorizacion(tarea: TareaDocumentoModel) {
        const diligencia = tarea['diligencia'];
        this.catalogoService.getOrganizacionById(tarea.organizacion.value).subscribe(({tipoOrganizacion: {firma}}: any) => {
            if (firma) {
                const adicional = tarea['diligencia']['adicionalFormData'];
                /*adicional['nombreEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('nombreCompletoUsuarioAutorizador');
                adicional['cargoEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('cargoUsuarioAutorizador');
                adicional['numeroEmpleadoEncargado'] = this.tokenStorage.getValueOfLocaleStorage('numEmpleadoUsuarioAutorizado');
                adicional['unidadEncargadoInvestigacion'] = this.tokenStorage.getValueOfLocaleStorage('unidadUsuarioAutorizador');
                adicional['idDiligencia'] = tarea['diligencia']['id'];
                tarea['diligencia']['adicionalFormData'] = adicional;
                this.catalogoService.updateAdicionalData({id: '', data: adicional}).subscribe(data => {
                });

                this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
                    .pipe(take(1))
                    .subscribe((value: any) => {
                        this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.openDialogEnAutorizar(tarea, false), 'Autorización');
                    });*/
            } else {
                this.mostrarModalParaAutorizacionMultiple();
            }
        });
    }

    mostrarModalParaAutorizacionMultiple() {
        console.log('listo para solicitar mas una autorización');
    }

    checkEstatus(tarea: TareaDocumentoModel, estatus: string): boolean {
        return tarea.estadoTareaActivo.estado.nombre === estatus;
    }

    enviar(tarea: TareaDocumentoModel) {
        this.sharedActions.enviarDiligencia(tarea['diligencia']).subscribe((res) => {
            console.log('enviada');
        });
    }

    isCreador(tarea: TareaDocumentoModel) {
        return tarea.createdBy === this.evkSecurity.getUsuarioInfo().username;
    }

    isTitularExpediente(tarea: TareaDocumentoModel) {
        return tarea.detalle.titularExpediente === this.evkSecurity.getUsuarioInfo().username;
    }

    isOficialSecretario() {
        // const roles = localStorage.getItem('roles').split(',');
        // if (roles.includes(RolEnum.ASISTENTE_EJECUTOR_TAREA)) {
        //     return true;
        // }
        return false;
    }
    hasRespuesta(tarea): boolean {
        return tarea.tareaRespuestas && tarea.tareaRespuestas.length > 0;
    }
}
